import PropTypes from "prop-types";
import React from "react";
import { Link } from "gatsby";
import loadable from '@loadable/component'


import { ProductsProvider } from "../context/products-context.js";
import {  NewCheckoutProvider } from "../context/checkout-context-v2.js";

import { checkTheme } from '../utils/informations'

import Icons from 'uikit/dist/js/uikit-icons';
import './index.scss'
import '@stripe/stripe-js'
import 'uikit/dist/css/uikit.css'
import UIkit from 'uikit'

const Seo = loadable(() => import("../components/seo/seo.js"))
const FooterSMH = loadable(() => import("../components/footer-smh/footer-smh.js"))
const Navbar = loadable(() => import("../components/navbar/navbar.js"))
const CookieConsent = loadable(() => import("react-cookie-consent"))
const CheckoutNavbar = loadable(() => import("../components/checkout-navbar/checkout-navbar.js"))


const Layout = ({ children, pageData , pageTitle}) => {


  
  UIkit.use(Icons);

  return (
  <ProductsProvider>
  <NewCheckoutProvider>
      <Seo title={pageTitle}></Seo>
      {
        
        pageTitle == `Checkout - ${checkTheme().pageTitle}` ? <CheckoutNavbar firstStep="Vehicle & Products" secondStep="Your details" thirdStep="Completion" checkoutType="vehicle" /> :
        pageTitle == `Wedding checkout - ${checkTheme().pageTitle}` ? <CheckoutNavbar firstStep="Participants & Events" secondStep="Products" thirdStep="Completion"  checkoutType="wedding"/> : 
        pageTitle == `Cancellation Rights - ${checkTheme().pageTitle}` || pageTitle == `Complaints Procedure - ${checkTheme().pageTitle}` ? <Navbar navBg="yes" /> : <Navbar navBg="false" />
      }
      <main>{children}</main>
      <FooterSMH></FooterSMH>
       <CookieConsent 
          // debug="true"
          location="bottom"
          cookieName={checkTheme().cookie}
          style={{background: "#5e5e5e", color: "#fff"}}
          buttonStyle={{background: checkTheme().color, color: "#fff"}}
          expires={150}
          >This website is using cookies to deliver you a better user experience. <Link to="/privacy-cookie-policy" style={{color: "#fff", textDecoration: "underline"}}>Find out more</Link></CookieConsent>
    </NewCheckoutProvider>
  </ProductsProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
